/**
 * Belegarten und Belegzustaende.
 *
 * Der Zustand eines Belegs hat zwei voneinander unabhaengige Achsen:
 *
 *   lifecycle - Ist der Beleg noch aenderbar? (GoBD)
 *   status    - Wo steht der Beleg fachlich? (offen, geliefert, bezahlt ...)
 *
 * Die Trennung ist wichtig: Eine festgeschriebene Rechnung darf ihren
 * Zahlungsstatus weiter aendern, ihre Positionen und Betraege aber nie.
 */
export const DOCUMENT_TYPES = {
    quote: {
        type: 'quote',
        label: 'Angebot',
        labelPlural: 'Angebote',
        prefix: 'AN',
        side: 'sales',
        createsAccountingEntries: false,
        createsStockMovements: false,
        followUps: ['sales_order'],
    },
    sales_order: {
        type: 'sales_order',
        label: 'Auftrag',
        labelPlural: 'Auftraege',
        prefix: 'AB',
        side: 'sales',
        createsAccountingEntries: false,
        createsStockMovements: false,
        followUps: ['delivery_note', 'invoice'],
    },
    delivery_note: {
        type: 'delivery_note',
        label: 'Lieferschein',
        labelPlural: 'Lieferscheine',
        prefix: 'LS',
        side: 'sales',
        createsAccountingEntries: false,
        createsStockMovements: true,
        followUps: ['invoice'],
    },
    invoice: {
        type: 'invoice',
        label: 'Rechnung',
        labelPlural: 'Rechnungen',
        prefix: 'RE',
        side: 'sales',
        createsAccountingEntries: true,
        createsStockMovements: false,
        followUps: ['credit_note'],
    },
    credit_note: {
        type: 'credit_note',
        label: 'Gutschrift',
        labelPlural: 'Gutschriften',
        prefix: 'GU',
        side: 'sales',
        createsAccountingEntries: true,
        createsStockMovements: false,
        followUps: [],
    },
    purchase_order: {
        type: 'purchase_order',
        label: 'Bestellung',
        labelPlural: 'Bestellungen',
        prefix: 'BE',
        side: 'purchase',
        createsAccountingEntries: false,
        createsStockMovements: false,
        followUps: ['goods_receipt'],
    },
    goods_receipt: {
        type: 'goods_receipt',
        label: 'Wareneingang',
        labelPlural: 'Wareneingaenge',
        prefix: 'WE',
        side: 'purchase',
        createsAccountingEntries: false,
        createsStockMovements: true,
        followUps: ['purchase_invoice'],
    },
    purchase_invoice: {
        type: 'purchase_invoice',
        label: 'Eingangsrechnung',
        labelPlural: 'Eingangsrechnungen',
        prefix: 'ER',
        side: 'purchase',
        createsAccountingEntries: true,
        createsStockMovements: false,
        followUps: [],
    },
};
export function getDocumentType(type) {
    const meta = DOCUMENT_TYPES[type];
    if (!meta)
        throw new Error(`Unbekannte Belegart: ${type}`);
    return meta;
}
/** Fachliche Status, die eine Belegart annehmen kann. */
export const DOCUMENT_STATUSES = {
    quote: ['open', 'accepted', 'rejected', 'expired'],
    sales_order: ['open', 'partially_delivered', 'delivered', 'completed'],
    delivery_note: ['open', 'completed'],
    invoice: ['open', 'partially_paid', 'paid'],
    credit_note: ['open', 'paid'],
    purchase_order: ['open', 'partially_delivered', 'delivered', 'completed'],
    goods_receipt: ['open', 'completed'],
    purchase_invoice: ['open', 'partially_paid', 'paid'],
};
export const DOCUMENT_STATUS_LABELS = {
    open: 'Offen',
    partially_delivered: 'Teilweise geliefert',
    delivered: 'Geliefert',
    partially_paid: 'Teilweise bezahlt',
    paid: 'Bezahlt',
    accepted: 'Angenommen',
    rejected: 'Abgelehnt',
    expired: 'Abgelaufen',
    completed: 'Abgeschlossen',
};
export const DOCUMENT_LIFECYCLE_LABELS = {
    draft: 'Entwurf',
    posted: 'Festgeschrieben',
    cancelled: 'Storniert',
};
/** Darf der Beleg inhaltlich noch geaendert werden? */
export function isEditable(lifecycle) {
    return lifecycle === 'draft';
}
/** Darf der Beleg geloescht werden? Nur Entwuerfe ohne Belegnummer. */
export function isDeletable(lifecycle) {
    return lifecycle === 'draft';
}
/** Kann der Beleg storniert werden? */
export function isCancellable(lifecycle) {
    return lifecycle === 'posted';
}
//# sourceMappingURL=documents.js.map